<template>
  <div>
    <b-row>
      <b-col cols="12" lg="12">
        <b-table
          id="tablaSolicitud"
          ref="tablaSolicitud"
          striped
          responsive
          hover
          stacked="md"
          :items="solicitudProvider"
          :fields="tablasolicitud.fields"
          :filter="filter"
          @filtered="onFiltered"
          :current-page="currentPagetablasolicitud"
          :per-page="perPagetablasolicitud"
          :small="true"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :no-local-sorting="true"
          show-empty
          :empty-text="'No se encontraron solicitudes recibidas para ' + this.personal.InformacionPersonal.DisplayDniNombre"
        >
          <template slot="empty" slot-scope="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template slot="HEAD_actions" slot-scope="head">{{ head.label }}</template>
          <template #cell(actions)="item">
            <input
              style="height:20px; width:20px; vertical-align: middle;"
              type="radio"
              name="checked"
              :key="item.index"
              :value="item.item"
              @click.stop
              v-model="SolicitudSeleccionada"
            >
          </template>
          <template #cell(AccionesSolicitud)="row">
            <b-button
              size="sm"
              @click="row.toggleDetails"
              class="mr-2"
            >{{ row.detailsShowing ? 'Ocultar' : 'Ver Cargos'}}</b-button>
          </template>
          <template slot="row-details" slot-scope="row">
            <cargo-personal-list :lista="row.item.ListaCargoPersonal"></cargo-personal-list>
          </template>
          <template #cell(FechaPresentacion)="row">{{ row.value | moment('DD/MM/YYYY') }}</template>
          <!--Template Pie de tabla-->
          <template slot="table-caption">
            <small>
              <b>Total solicitudes enviadas :</b>
            </small>
            <b-badge variant="success">{{ this.totalRows }}</b-badge>
            <small>
              |
              <b>Ordenado por :</b>
              {{ sortBy }} {{ (sortDesc ? 'desc' : 'asc') }}
            </small>
          </template>
        </b-table>
        <b-row>
          <b-col md="6">
            <b-pagination
              size="sm"
              :total-rows="this.totalRows"
              :per-page="perPagetablasolicitud"
              v-model="currentPagetablasolicitud"
              class="my-0"
            ></b-pagination>
          </b-col>
          <b-col md="6">
            <b-form-group breakpoint="sm" horizontal label="Por página: " class="mb-3">
              <b-form-select size="sm" :options="pageOptions" v-model="perPagetablasolicitud"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CargoPersonalList from "./CargoPersonalList.vue";
import Solicitudsvc from '@/services/solicitudes'
import moment from "moment";

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'FormLicenciaModule/getLicenciaField',
  mutationType: 'FormLicenciaModule/updateLicenciaField',
});

export default {
  components: { CargoPersonalList },
  name: "SolicitudTableSelect",
  props: {
    personal: Object
  },
  data() {
    return {
      filter: '',
      sortBy: 'FechaPresentacion',
      sortDesc: true,
      currentPagetablasolicitud: 1,
      perPagetablasolicitud: 5,
      pageOptions: [5, 10, 15],
      totalRows: null,
      tablasolicitud: {
        fields: [
          {
            key: 'actions',
            label: '',
            class: 'text-right'
          },
          {
            key: 'Id',
            label: 'Id',
            class: "text-center"
          },
          {
            key: 'ToString',
            label: 'DNI - Personal',
          },
          {
            key: 'FechaPresentacion',
            label: 'Enviada',
            class: "text-center"
          },
          {
            key: 'AccionesSolicitud',
            label: 'Acciones',
            class: "text-center"
          },
        ],
      }
    };
  },
  watch: {
    SolicitudSeleccionada(newval, oldval) {
      console.log('solicitudSeleccionada old', oldval);
      console.log('solicitudSeleccionada new', newval);
      if(newval === null){
        console.log('solicitudSeleccionada null refresh', newval);
        this.$refs.tablaSolicitud.refresh();
      }
    },
  },
  computed: {
    ...mapFields([
        "SolicitudSeleccionada",
        "SolicitudSeleccionada_Id",]),
    fechaSolicitud: function() {
      return moment(this.solicitud.Fecha).format("DD MMM YYYY HH:MM");
    },
    fechaAusenteDesde: function() {
      return moment(this.solicitud.FechaDesde).format("DD MMM YYYY HH:MM");
    }
  },
  methods:{
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPagetablasolicitud = 1
    },
    solicitudProvider: function (ctx)
    {
      console.log('solicitudprovider', ctx);
      let promise = Solicitudsvc.getLista(
        {
          incluyecargopersonal: true,
          Id:'',
          Personal_Id: this.personal.Id,
          EstadoSolicitudMedica: 5, //5-Recibido
          offset:(this.currentPagetablasolicitud-1) * this.perPagetablasolicitud,
          limit:this.perPagetablasolicitud,
          //search:this.documento,
          sort: ctx.sortBy === 'FechaPresentacion' ? 3 : 0,
          order: ctx.sortDesc ? 'desc': 'asc'
        });

      return promise.then(r => {
        const items = r.data.rows;
        this.totalRows = r.data.total;
        return (items)
      }).catch(error=>{
        console.log("Error en solicitudProvider");
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/SolicitudTableSelect.vue